/**
 * Review Carousel Section
 * Interactive review carousel with Splide.js
 */

(function() {
  function initReviewCarousel(sectionId, hasMultipleBlocks) {
    const sectionContainer = document.getElementById('shopify-section-' + sectionId);
    if (!sectionContainer) return;

    const splideElementId = 'splide-' + sectionId;
    const splideElement = sectionContainer.querySelector('#' + splideElementId);
    if (!splideElement) return;

    const anchorLinks = sectionContainer.querySelectorAll('[data-anchor-id]');

    function initSplide() {
      if (typeof Splide === 'undefined') {
        if (window.__splideReady) {
          window.__splideReady.then(function() {
            initSplide();
          });
        }
        return;
      }

      let splideInstance = null;

      function initSplideInstance() {
        if (splideInstance) {
          splideInstance.destroy();
          splideInstance = null;
        }

        const isXlBreakpoint = window.matchMedia('(width >= 85.375rem)').matches;

        const config = {
          type: 'slide',
          perMove: 1,
          gap: '1.5rem',
          pagination: false,
          arrows: false,
          drag: true,
          snap: true,
          width: '100%',
          speed: 400,
          easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
          updateOnMove: true,
          fixedWidth: '286px',
          padding: { left: '3rem', right: '3rem' },
          breakpoints: {
            1365: {
              destroy: false,
              focus: 'center',
              gap: '1rem',
              padding: { left: '1.5rem', right: '1.5rem' },
            },
          },
        };

        // At the highest breakpoint (85.375rem / 1366px), destroy Splide to show all items as grid
        if (isXlBreakpoint) {
          config.destroy = true;
        }

        if (!hasMultipleBlocks) {
          config.destroy = true;
        }

        splideInstance = new Splide('#' + splideElementId, config);
        splideInstance.mount();
      }

      initSplideInstance();

      // Handle window resize to reinitialize Splide when crossing breakpoint
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          initSplideInstance();
        }, 250);
      });
    }

    function handleAnchorClick(e) {
      const anchorId = e.currentTarget.getAttribute('data-anchor-id');
      if (!anchorId) return;

      e.preventDefault();
      const targetElement = document.querySelector('[target-id="' + anchorId + '"]');
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      } else {
        console.warn('No element found with target-id="' + anchorId + '"');
      }
    }

    anchorLinks.forEach(function(link) {
      link.addEventListener('click', handleAnchorClick);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSplide);
    } else {
      initSplide();
    }
  }

  // Initialize all review carousel sections on the page
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('[data-review-carousel-section]');
    sections.forEach(function(section) {
      const sectionId = section.getAttribute('data-review-carousel-section');
      const hasMultipleBlocks = section.getAttribute('data-has-multiple-blocks') === 'true';
      initReviewCarousel(sectionId, hasMultipleBlocks);
    });
  });
})();

